import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useI18n } from "../context/I18nContext";
import { formatApiErrorDetail } from "../lib/api";
import { toast } from "sonner";

export default function Register() {
  const { t } = useI18n();
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const user = await register(form.email, form.password, form.name);
      toast.success(t.auth.loginTitle);
      navigate(user?.role === "admin" ? "/dashboard" : "/");
    } catch (e) {
      setError(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-[calc(100vh-96px)] flex items-center justify-center py-20 px-6" data-testid="register-page">
      <div className="w-full max-w-md">
        <h1 className="headline text-4xl sm:text-5xl text-[#1d1d1f] mb-2">{t.auth.registerTitle}</h1>
        <p className="text-[16px] text-[#86868b] mb-10">{t.auth.registerSubtitle}</p>

        <form onSubmit={submit} className="space-y-4">
          <Field label={t.auth.name} value={form.name} onChange={(v) => setForm({ ...form, name: v })} testid="register-name-input" required />
          <Field label={t.auth.email} type="email" value={form.email} onChange={(v) => setForm({ ...form, email: v })} testid="register-email-input" required />
          <Field label={t.auth.password} type="password" value={form.password} onChange={(v) => setForm({ ...form, password: v })} testid="register-password-input" required />

          {error && <div className="text-[13px] text-red-600" data-testid="register-error">{error}</div>}

          <button type="submit" disabled={loading} className="w-full btn-pill btn-primary text-[14px] disabled:opacity-50" data-testid="register-submit-btn">
            {loading ? "…" : t.auth.registerBtn}
          </button>
        </form>

        <p className="text-center text-[13px] text-[#86868b] mt-8">
          {t.auth.hasAccount}{" "}
          <Link to="/login" className="text-[#1d1d1f] hover:underline" data-testid="link-to-login">
            {t.auth.loginBtn}
          </Link>
        </p>
      </div>
    </main>
  );
}

function Field({ label, value, onChange, type = "text", testid, required }) {
  return (
    <div>
      <label className="block text-[12px] uppercase tracking-wider text-[#86868b] mb-1">{label}</label>
      <input
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        required={required}
        className="w-full bg-[#f5f5f7] rounded-2xl px-4 py-3 text-[14px] outline-none"
        data-testid={testid}
      />
    </div>
  );
}
